import type { IntegrationLogPayload } from "@/lib/api/types";

/**
 * Presentation helpers shared by the integration-log list and its detail
 * drawer. Kept out of the components so both surfaces render identical values.
 */

/** Placeholder for a nullable column — matches the em dash used elsewhere. */
export const EMPTY_CELL = "—";

export function formatLogTimestamp(iso: string, locale: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return iso;
  }

  return date.toLocaleString(locale);
}

export function formatDurationMs(
  durationMs: number | null,
  suffix: string,
): string {
  if (durationMs === null) {
    return EMPTY_CELL;
  }

  return `${durationMs}${suffix}`;
}

/**
 * Pretty-prints an already-parsed JSON payload for the `<pre>` viewer.
 * Payloads arrive redacted from the backend, so no masking happens here.
 */
export function formatJsonPayload(
  payload: IntegrationLogPayload,
): string | null {
  if (payload === null || payload === undefined) {
    return null;
  }

  if (typeof payload === "string") {
    return payload;
  }

  try {
    return JSON.stringify(payload, null, 2);
  } catch {
    // Circular structures should never reach the client, but a payload we
    // cannot stringify must not blank out the whole drawer.
    return String(payload);
  }
}
